import { useAuth } from "@/src/contexts/auth.context";
import { Post } from "@/src/models/post.model";
import {
  useGetUserProfileQuery,
  useToggleSavePostMutation,
} from "@/src/services/profile/profile.hooks";

export const useToggleSavePost = (post: Post | null) => {
  const { user } = useAuth();
  const userId = user?.itemId ?? "";
  const postId = post?.ItemId ?? "";
  const { data: userProfile } = useGetUserProfileQuery(userId);
  const { mutate: toggleSave } = useToggleSavePostMutation();

  const isSaved = userProfile?.savedPostIds?.includes(postId) ?? false;

  const handleToggleSave = () => {
    if (!userProfile || !post) return;

    const currentSavedIds = userProfile.savedPostIds ?? [];

    const updatedSavedPostIds = isSaved
      ? currentSavedIds.filter((savedId) => savedId !== postId)
      : [...currentSavedIds, postId];
    toggleSave({
      userProfileId: userProfile.ItemId,
      savedPostIds: updatedSavedPostIds,
      postId,
      postSaveCount: post.saveCount ?? 0,
    });
  };

  return { isSaved, handleToggleSave };
};
